import { formatCurrency } from "../../../helpers/utils";
import { TablePlaceholder } from "../../../components/placeholders";

export default function HistorySummary({
  startDate,
  endDate,
  items,
  onCalendarOpen,
  loading,
  setSelectedModal,
}) {
  const formatDate = (date) =>
    date ? new Date(date).toISOString().split("T")[0] : "YYYY-MM-DD";

  const totalAmount = items.reduce(
    (sum, item) => sum + (item.totalAmount || 0),
    0
  );
  const totalDeliveryPrice = items.reduce(
    (sum, item) => sum + (Number(item.deliveryPrice) || 0),
    0
  );

  return (
    <div className="card">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table mb-0">
            <tbody>
              {loading ? (
                <TablePlaceholder rows={4} count={2} />
              ) : (
                <>
                  <tr>
                    <td className="align-middle">Эхлэх огноо:</td>
                    <td className="align-middle">
                      <div
                        className="form-control"
                        onClick={() => {
                          onCalendarOpen();
                          setSelectedModal("start");
                        }}
                      >
                        {formatDate(startDate)}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="align-middle">Дуусах огноо:</td>
                    <td className="align-middle">
                      <div
                        className="form-control"
                        onClick={() => {
                          onCalendarOpen();
                          setSelectedModal("end");
                        }}
                      >
                        {formatDate(endDate)}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Дуудлагын тоо:</td>
                    <td>{items.length}</td>
                  </tr>
                  <tr>
                    <td>Нийт төлбөр:</td>
                    <td>{formatCurrency(totalDeliveryPrice)}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
